import { routes } from "@constants/routes";
import {
  IndustryForm,
  useResumeStore,
  UserTypeEnum,
  WorkExperienceForm,
  WorkExperienceTable,
} from "@cpj-ai/panel-npm-package";
import {
  useGetProfileIndustryQuery,
  useGetWorkExperienceByIdLazyQuery,
  useGetWorkExperiencesQuery,
} from "@graphql/generated";
import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
export type WorkState = "TABLE" | "FORM";

const WorkExperienceTabContent = () => {
  const params = useParams();
  const [workState, setWorkState] = useState<WorkState>("TABLE");
  const { setWorkExperienceEditId } = useResumeStore();
  const { data, refetch, loading } = useGetWorkExperiencesQuery({ variables: { id: Number(params.id) } });
  const { data: industryData } = useGetProfileIndustryQuery({ variables: { id: Number(params.id) } });
  const [getExperienceInfoById, { data: experienceInfo, loading: getExperienceInfoLoading }] =
    useGetWorkExperienceByIdLazyQuery();
  useEffect(() => {
    setWorkExperienceEditId(undefined);
  }, [setWorkExperienceEditId]);

  const location = useLocation();

  return (
    <div>
      {workState === "TABLE" ? (
        <>
          <IndustryForm
            industry={industryData?.admin?.jobSeekers?.edges[0]?.node?.profile?.industry}
            isDisabled={true}
          />
          <WorkExperienceTable
            setWorkState={setWorkState}
            workState={workState}
            handleNextTab={() => {}}
            data={data?.admin?.jobSeekers?.edges[0]?.node?.workexperiences}
            refetch={refetch}
            loading={loading}
            showAddNewSection={false}
          />
        </>
      ) : (
        <WorkExperienceForm
          setWorkExperienceState={setWorkState}
          supportUrl={routes.support.main}
          pathname={location.pathname}
          getExperienceInfoById={getExperienceInfoById}
          experienceInfo={experienceInfo?.admin?.workExperience}
          getExperienceInfoLoading={getExperienceInfoLoading}
          userType={UserTypeEnum.ADMIN}
        />
      )}
    </div>
  );
};

export default WorkExperienceTabContent;
